<template>
  <div class="container">
    <div class="row">
      <div id="step1" class="col-xs-12 text-center">
        <h3>Welcome!</h3>
        <p>
          In a few quick steps, we’ll guide you through creating your license
          management account. This account is meant to be used for placing
          orders and handling the administration / billing related tasks. Once
          you’ve finished the checkout process, you’ll use this account to
          assign the licenses you are purchasing.
        </p>
        <br />
        <registration-progress-bar
          title-reg="What type of product do you intend to purchase?"
          progress="20"
        ></registration-progress-bar>
        <br />
        <div class="row">
          <div
            v-for="customerSegment in customerSegments"
            :key="`customer-segment-${customerSegment.id}`"
            class="col-sm-6"
          >
            <h4>{{ customerSegment.name }}</h4>
            <button
              :id="'step1' + customerSegment.slug"
              type="button"
              class="btn btn-primary btn-block"
              @click.prevent="nextStep(customerSegment)"
            >
              {{ customerSegment.name }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <scroll></scroll>
  </div>
</template>

<script>
export default {
  props: {
    customerSegments: {
      type: Array,
      required: true,
    },
  },

  created() {
    this.$store.dispatch("reSetNpiInfo");
  },

  methods: {
    nextStep(customerSegment) {
      this.$store.dispatch("setCustomerSegment", customerSegment);
      this.$store.dispatch("nextStep");
    },
  },
};
</script>
